module.exports = __webpack_public_path__ + "img/boxy_background.a323c274.jpg";